import request from 'superagent';
import { STRINGS } from 'config';
import { Dispatch } from 'react';

const {
  CUSTOMISATION: {
    HOST,
    FEATURE_GROUP,
  },
  REDUCERS: {
    FEATURE_FLAGS: {
      GET_FEATURE_FLAGS_REQUEST,
      GET_FEATURE_FLAGS_SUCCESS,
      GET_FEATURE_FLAGS_ERROR,
    },
  },
} = STRINGS;

export const getFeatureFlags = (practiceId: string) => async (dispatch: Dispatch<unknown>): Promise<unknown> => {
  dispatch({ type: GET_FEATURE_FLAGS_REQUEST });
  try {
    const response = await request
      .get(`${HOST}/group/${FEATURE_GROUP}`)
      .set({ 'X-OWNER-ID': practiceId });
    return dispatch({ type: GET_FEATURE_FLAGS_SUCCESS, payload: response.body.values });
  } catch (error) {
    return dispatch({ type: GET_FEATURE_FLAGS_ERROR, payload: error });
  }
};
